(function supportCustomerAccountsUX(scope) {
  'use strict';
  const TARGET_THEME = '184880791825';
  const knownPaths = {
    '/collections/tryon': 'tryon',
    '/pages/online-fit-system': 'fit',
    '/pages/lifetime-care-program': 'care',
    '/pages/support': 'support'
  };
  function labelKey(href, text, base) {
    let url;
    try { url = new URL(href, base); } catch { return null; }
    if (url.protocol !== 'https:' || url.hostname !== '2nu.vision' || url.username || url.password) return null;
    // Only shorten a bare URL. Keep authored link wording and all destinations intact.
    if (text.trim() !== url.href && text.trim() !== href) return null;
    const route = url.pathname.replace(/^\/(?:en|zh)(?:-[a-z0-9]+)*(?=\/)/i, '').replace(/\/$/, '');
    if (knownPaths[route]) return knownPaths[route];
    if (/^\/products\/[^/]+$/.test(route)) return 'product';
    if (/^\/collections\/[^/]+$/.test(route)) return 'collection';
    if (/^\/pages\/[^/]+$/.test(route)) return 'details';
    return null;
  }
  if (typeof module === 'object' && module.exports) module.exports = { labelKey };
  if (!scope.document) return;
  const doc = scope.document;
  function boot() {
    const source = doc.querySelector('[data-two-nu-support-ux-copy]');
    if (!source || source.dataset.themeId !== TARGET_THEME || source.dataset.mounted) return;
    let copy;
    try { copy = JSON.parse(source.textContent); } catch { return; }
    if (!copy.more) return;
    source.dataset.mounted = 'true';
    let mountedHeader = null;
    let closeMenu = () => {};
    function scan() {
      const panel = doc.getElementById('TwoNuSupportChatPanel');
      const root = panel?.closest('[data-two-nu-support-chat]');
      const header = panel?.querySelector('.two-nu-support-chat__header');
      if (!root || !header) return;
      root.classList.add('two-nu-support-ux');
      const email = header.querySelector('.two-nu-email-launcher');
      if (email && !mountedHeader) {
        mountedHeader = header;
        const host = doc.createElement('div'); host.className = 'two-nu-ux-more';
        const button = doc.createElement('button'); button.type = 'button';
        button.className = 'two-nu-ux-more-button'; button.textContent = '⋯';
        button.setAttribute('aria-label', copy.more); button.title = copy.more;
        button.setAttribute('aria-expanded', 'false'); button.setAttribute('aria-controls', 'TwoNuSupportMoreOptions');
        const menu = doc.createElement('div'); menu.id = 'TwoNuSupportMoreOptions'; menu.className = 'two-nu-ux-more-options';
        menu.hidden = true; menu.setAttribute('role', 'group'); menu.setAttribute('aria-label', copy.more);
        header.insertBefore(host, email); host.append(button, menu); menu.append(email);
        const emailLabel = copy.email || email.getAttribute('aria-label') || 'Email notifications';
        email.setAttribute('aria-label', emailLabel); email.title = emailLabel;
        const label = doc.createElement('span'); label.textContent = emailLabel; email.append(label);
        closeMenu = (restore = false) => { menu.hidden = true; button.setAttribute('aria-expanded', 'false'); if (restore) button.focus({ preventScroll: true }); };
        button.addEventListener('click', () => {
          if (!menu.hidden) { closeMenu(); return; }
          menu.hidden = false; button.setAttribute('aria-expanded', 'true');
          if (!email.disabled) email.focus({ preventScroll: true });
        });
        email.addEventListener('click', () => closeMenu());
        host.addEventListener('keydown', event => {
          if (event.key === 'Escape' && !menu.hidden) { event.stopPropagation(); event.preventDefault(); closeMenu(true); }
        });
        doc.addEventListener('pointerdown', event => { if (!host.contains(event.target)) closeMenu(); });
        panel.querySelector('[data-support-chat-close]')?.addEventListener('click', () => closeMenu());
        new MutationObserver(() => { if (panel.hidden) closeMenu(); }).observe(panel, { attributes: true, attributeFilter: ['hidden'] });
      }
      for (const link of panel.querySelectorAll('.two-nu-support-chat__message--assistant .two-nu-chat-body a[href], .two-nu-support-chat__message--human .two-nu-chat-body a[href]')) {
        const key = labelKey(link.getAttribute('href'), link.textContent, doc.baseURI);
        if (!key || !copy[key]) continue;
        link.textContent = copy[key]; link.classList.add('two-nu-ux-link');
        link.title = link.href;
      }
    }
    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true; queueMicrotask(() => { queued = false; scan(); });
    });
    // The App embed may arrive after this theme script. No transport handlers are replaced.
    observer.observe(doc.body, { childList: true, subtree: true });
    scan();
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})(typeof window === 'undefined' ? globalThis : window);
